import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { HowItWorksDiscountTableData } from './HowItWorksDiscountTableData'

const customSup = (data: ReactNode): ReactNode => (
  <sup className="leading-none" key="prescriptionBonus.modal.intro.sup">
    {data}
  </sup>
)

export const HowItWorksTable: FC = () => {
  return (
    <>
      <div className="text-m font-medium">
        <FormattedMessage id="prescriptionBonus.modal.howItWorks" />
      </div>
      <p className="mt-1">
        <FormattedMessage
          id="prescriptionBonus.modal.intro"
          values={{
            sup: customSup,
          }}
        />
      </p>
      <p className="mb-4 text-m font-medium">
        <FormattedMessage id="prescriptionBonus.modal.discountTable.title" />
      </p>
      <div className="flex flex-col items-center self-stretch">
        <div className="flex items-center justify-center self-stretch rounded-s bg-light-secondary-medium">
          <div className="flex flex-1 items-center justify-center px-2 py-1 text-xs text-dark-primary-max">
            <span>
              <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.header.0" />
            </span>
          </div>
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
            className="flex w-[120px] items-center justify-center px-2 py-1"
          >
            <span className="text-xs text-dark-primary-max">
              <FormattedMessage id="prescriptionBonus.modal.howItWorks.discount.table.header.1" />
            </span>
          </div>
        </div>
        {HowItWorksDiscountTableData.map(({ key, row1, row2 }) => (
          <div
            className="mt-1 flex items-center justify-center self-stretch rounded-s bg-light-brand-medium"
            key={key}
          >
            <div className="flex flex-1 items-center justify-center px-2 py-1 text-xs text-dark-primary-max">
              <span>{row1}</span>
            </div>
            <div
              // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
              className="m-1 flex w-[120px] items-center justify-center rounded-s bg-light-tertiary px-2 py-1"
            >
              <span className="font-mono text-xs text-dark-primary-max">
                {row2}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
